export enum AttachmentType {
  AFFIDAVIT = 'Affidavit',
  AFFIRMATION = 'Affirmation',
  ALIAS_SUMMONS = 'Alias Summons',
  AMENDED = 'Amended',
  ANSWER = 'Answer',
  APPEARANCE = 'Appearance',
  APPLICATION = 'Application',
  APPOINTMENT_DOCUMENT = 'Appointment Document',
  ARBITRATION = 'Arbitration',
  BILL_OF_COST = 'Bill of Cost',
  BILL_OF_PARTICULARS = 'Bill of Particulars',
  BOND = 'Bond',
  CERTIFICATE = 'Certificate',
  COMPLAINT = 'Complaint',
  CONFIDENTIAL = 'Confidential',
  COURT_DOCUMENT = 'Court Document',
  COVER_SHEET = 'Cover Sheet',
  DECLARATION_DOCUMENT = 'Declaration Document',
  DEFAULT = 'Default',
  DISCOVERY = 'Discovery',
  DISMISSAL = 'Dismissal',
  DISPOSITION = 'Disposition',
  DISPOSSESSORY_PROCEEDING = 'Dispossessory Proceeding',
  DOCKET_REPORT = 'Docket Report',
  DOC_SUBMISSION = 'Doc Submission',
  EVICTION = 'Eviction',
  EXECUTION = 'Execution',
  EXHIBITS = 'Exhibits',
  GARNISHMENT = 'Garnishment',
  GROUNDS_OF_DEFENSE = 'Grounds of Defense',
  INFORMATION = 'Information',
  INTEREST = 'Interest',
  INTERROGATORIES = 'Interrogatories',
  JUDGEMENT = 'Judgement',
  LEASE_AGREEMENT = 'Lease Agreement',
  LEASE_APPLICATION = 'Lease Application',
  LEDGER = 'Ledger',
  LETTER = 'Letter',
  LIEN = 'Lien',
  MEMORANDUM = 'Memorandum',
  MISCELLANEOUS = 'Miscellaneous',
  MOTION = 'Motion',
  NOTICE = 'Notice',
  OATH = 'Oath',
  ORDER = 'Order',
  OTHER = 'Other',
  PETITION = 'Petition',
  PRAECIPE = 'Praecipe',
  PROOF_OF_SERVICE = 'Proof of Service',
  REPLY = 'Reply',
  REQUEST_DOCUMENT = 'Request Document',
  RETURN_OF_SERVICE = 'Return of Service',
  SATISFACTION = 'Satisfaction',
  SCRA_DOCUMENT = 'Scra Document',
  SERVICE = 'Service',
  STATEMENT = 'Statement',
  STIPULATION = 'Stipulation',
  SUBSTITUTION = 'Substitution',
  SUMMARY_EJECTMENT = 'Summary Ejectment',
  SUMMONS = 'Summons',
  SUPPORTING_DOCUMENT = 'Supporting Document',
  VERIFICATION = 'Verification',
  WARRANT = 'Warrant',
  WRIT = 'Writ'
}
